module.exports = __webpack_public_path__ + "img/de252514.fa816306.jpg";